import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'
import gameData from '../gameData';
import UIAssetKeys from '../UIAssetKeys';
import FontKeys from '../FontKeys';

export default class OptionLayer extends Phaser.GameObjects.Container
{
    /**
     * 
     * @param {Phaser.Scene} scene 
     */
    constructor(scene, itemRootName, spriteSheet, text, itemTotal, totalColumnCount, isSpecial)
    {
        super(scene);

        this.backgroundShape = this.scene.add.rectangle(0, 50, this.scene.scale.width, this.scene.scale.height - 50, 0x000000, 0.7).setOrigin(0).setInteractive();
        this.add(this.backgroundShape);

        this.backgroundShape.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.dismissEvent, this);

        if (!isSpecial)
        {
            this.items = [];

            let posY = 60;
            for (let i = 0; i < itemTotal; i++)
            {
                let spriteName = itemRootName + (i + 1);
                let fontSize = 42;
                let labelTxt = Array.isArray(text) ? text[i] : text;
                let font = itemRootName === 'f' ? gameData.fonts[i] : FontKeys._BPreplayBold;

                if(itemRootName === "w")
                {
                  spriteName = "w1";
                  fontSize = 72;
                }
                else if(itemRootName === 'f')
                {
                  spriteName = "w1";
                  fontSize = 36;
                }

                let itemSprite = this.scene.add.container(0,0);
                this.add(itemSprite);
                const bg = ABCyaPhaser.Images.addImage(0, 0, spriteName, itemSprite, spriteSheet).setOrigin(0);
                itemSprite.setSize(bg.width, bg.height);
                ABCyaPhaser.Container.setContainerInteractive(itemSprite);
                const txt = ABCyaPhaser.Text.addText(bg.width/2, bg.height/2, fontSize, 0x008bbc, font, labelTxt, itemSprite).setWordWrapWidth(210).setLineSpacing(-6).setResolution(2);
                ABCyaPhaser.Text.resizeFontToFitWidth(txt, 210, 110);

                if(itemRootName === 'w'){
                  txt.y = 107;
                }
                else if (itemRootName !== 'f'){
                  txt.y = txt.height > 75 ? 68 : 60;
                }
                                
                itemSprite.number = i + 1;

                itemSprite.x = 10 + ((itemSprite.width + 10) * (i % totalColumnCount));
                if (i % totalColumnCount == 0 && i > 0)
                {
                    posY += itemSprite.height + 10;
                }

                itemSprite.y = posY;

                itemSprite.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => this.handleOptionClicked(itemSprite.number));

                this.scene.tweens.timeline({
                    tweens:
                        [
                            ABCyaPhaser.Tweens.createTween(itemSprite, 70, { angle: 10 }, Phaser.Math.Easing.Linear),
                            ABCyaPhaser.Tweens.createTween(itemSprite, 250, { angle: 0 }, Phaser.Math.Easing.Bounce.Out),
                        ]
                });

                // add toggle to 'word filter' menu options
                this.items.push(itemSprite);
            }

            if (itemRootName == "m")
            {
                this.toggle = null;

                if (gameData.FILTER_ON)
                {
                    this.toggle = ABCyaPhaser.Images.addImage(this.scene.scale.width / 2 - 310, this.scene.scale.height / 2 + 84, UIAssetKeys._check_mark, this);
                }
                else
                {
                    this.toggle = ABCyaPhaser.Images.addImage(this.scene.scale.width / 2 - 450, this.scene.scale.height / 2 + 84, UIAssetKeys._x_mark, this);
                }
            }
        }
        else
        {
            this.items = [];
            //deal with 'layout' layer that has 4 items in top row and two rows of 6 items

            let posY = 60;
            let firstRowItemHeight = null;

            for (let i = 0; i < 4; i++)
            {
                let itemSprite = ABCyaPhaser.Images.addImage(0, 0, itemRootName + (i + 1), this, spriteSheet).setOrigin(0).setInteractive();
                itemSprite.x = 10 + ((itemSprite.width + 10) * (i % 4));
                itemSprite.y = posY;

                firstRowItemHeight = itemSprite.height;
                itemSprite.number = i + 1;

                itemSprite.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => this.handleOptionClicked(itemSprite.number));

                this.scene.tweens.timeline({
                    tweens:
                        [
                            ABCyaPhaser.Tweens.createTween(itemSprite, 70, { angle: 10 }, Phaser.Math.Easing.Linear),
                            ABCyaPhaser.Tweens.createTween(itemSprite, 250, { angle: 0 }, Phaser.Math.Easing.Bounce.Out),
                        ]
                });

                this.items.push(itemSprite);
            }

            posY = 60;
            posY += firstRowItemHeight + 8;

            //limit shapes to 'built-in' ones for now
            for (let i = 0; i < 6; i++)
            {
                let itemSprite = ABCyaPhaser.Images.addImage(0, 0, itemRootName + (i + 5), this, spriteSheet).setOrigin(0).setInteractive();
                itemSprite.x = 10 + ((itemSprite.width + 10) * (i % 6));
                if (i % 6 == 0 && i > 0)
                {
                    posY += itemSprite.height + 8;
                }

                itemSprite.y = posY;
                itemSprite.number = i + 5;

                itemSprite.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => this.handleOptionClicked(itemSprite.number));

                this.scene.tweens.timeline({
                    tweens:
                        [
                            ABCyaPhaser.Tweens.createTween(itemSprite, 70, { angle: 10 }, Phaser.Math.Easing.Linear),
                            ABCyaPhaser.Tweens.createTween(itemSprite, 250, { angle: 0 }, Phaser.Math.Easing.Bounce.Out),
                        ]
                });

                this.items.push(itemSprite);
            }
        }
    }

    dismissEvent()
    {
        this.emit("DISMISS");
    }

    handleOptionClicked(index)
    {
        this.emit("selected", index);
    }

    toggleWordFilter()
    {
        this.toggle.destroy();

        gameData.FILTER_ON = !gameData.FILTER_ON;

        if (gameData.FILTER_ON)
        {
            this.toggle = ABCyaPhaser.Images.addImage(this.scene.scale.width / 2 - 310, this.scene.scale.height / 2 + 84, UIAssetKeys._check_mark, this);
        } 
        else
        {
            this.toggle = ABCyaPhaser.Images.addImage(this.scene.scale.width / 2 - 450, this.scene.scale.height / 2 + 84, UIAssetKeys._x_mark, this);
        }
    }
}